import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as routes from '../../constants/routes'
import { withRouter } from 'react-router-dom'
import withAuthorization from '../withAuthorization';


const HomePage = (props) => {
  

    const { currentUser, history } = props

    if(currentUser!==null){
   
      if(currentUser.role==='admin'){
        history.push(routes.ADMINHOME)

      }
    }
  
    return (
      <div>
        <h1>Startseite</h1>
        <p>Herzliche Willkommen bei .....</p>
        
      </div>
    );

}


const mapStateToProps = (state) => ({
  currentUser: state.userState.profile,
  userId: state.sessionState.authUser.uid,
});

const mapDispatchToProps = (dispatch) => ({
  onSetUsers: (users) => dispatch({ type: 'USERS_SET', users }),
});

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(HomePage);


// WEBPACK FOOTER //
// ./src/Components/App/Home.js